import type { FC } from 'react'
import type { DivingDadEvent } from '../content/divingDads'

const statusLabel: Record<DivingDadEvent['status'], string> = {
  proposed: 'Proposed',
  confirmed: 'Confirmed'
}

type EventCardProps = {
  readonly event: DivingDadEvent
}

const EventCard: FC<EventCardProps> = ({ event }) => {
  return (
    <article className='diving-dads-event' id={`event-${event.id}`}>
      <span className={`diving-dads-event__status diving-dads-event__status--${event.status}`}>
        {statusLabel[event.status]}
      </span>
      <h3 className='diving-dads-event__title'>{event.title}</h3>
      <dl className='diving-dads-event__meta'>
        <div>
          <dt>When</dt>
          <dd>{event.when}</dd>
        </div>
        <div>
          <dt>Where</dt>
          <dd>{event.where}</dd>
        </div>
      </dl>
      <p className='diving-dads-event__description'>{event.description}</p>
      {event.details && event.details.length > 0 && (
        <ul className='diving-dads-event__details'>
          {event.details.map((line) => (
            <li key={line.slice(0, 48)}>{line}</li>
          ))}
        </ul>
      )}
    </article>
  )
}

export default EventCard
